import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FacultyService {

  constructor(private http: HttpClient) {

  }

  search(query:any){
  	let configUrl = "http://api.thegbu.in/faculty/"+query;
  	return this.http.get(configUrl);
  }

  facultyProfile(fname:any){
  	let configUrl = "http://api.thegbu.in/facultyprofile/"+fname;
  	return this.http.get(configUrl);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/faculty.service.ts